import { Injectable } from '@angular/core';
import { DatePipe } from '@angular/common';

import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { AvlaRestClientService } from 'base-angular-avla';
import * as moment from 'moment';

import { clientDataDto } from '../../DTOs/clientDTO';
import { clientResultsDto } from '../../DTOs/clientResultsDto';
import { C360PersonFormResponsesDTO } from '../../DTOs/C360PersonFormResponsesDTO';
import { C360PersonScoreDTO } from '../../DTOs/C360PersonScoreDTO';
import { amaruCodeCountry, businessScore } from './../constants';
import { responsePaginatedDTO } from '../../DTOs/responsePaginatedDTO';
import { resAmaruDTO } from '../../DTOs/resAmaruDTO';
import { ScoreTableItem } from '../../DTOs/score-table-item.model';
import { C360ProspectFormResponsesDTO } from '../../DTOs/C360ProspectFormResponsesDTO';
import { C360ProspectScoreDTO } from '../../DTOs/C360ProspectScoreDTO';
import { LineScoreDto } from '../../DTOs/responses/lineScoreDto';
import { SourceSystemDTO } from 'app/DTOs/sourceSystemDTO';
import { of } from 'rxjs';
import { ScoreConfigFactory } from 'app/components/score/score-config-factory';
import { AmaruEconomicGroupDTO } from 'app/DTOs/amaruGroupEconomicDTO';
import { base64String, resArticoProposalDTO } from 'app/DTOs/resArticoProposalDTO';
import { ScoreConfig } from 'app/DTOs/score-config.model';
import { ParameterDTO } from 'parameters-front-components';
import { OptionCombobox } from 'dynamicform-front-components';
import { DeductibleRequestStoreService  } from 'app/shared/services/deductible-request-store.service';


@Injectable({
  providedIn: 'root'
})
export class ClientService {
  public static getClienturl = 'client360-api/findPersonByDniOrName';
  public static getClientResult =
    'client360-api/findPersonsByIdentificationOrNameClient360';
  public static getClientResultES =
    'client360-api/findByNameOrIdentificationEs';
  public static generateDocUrl = 'client360-api/generateDocumentClient';
  public static getProductUrl = 'client360-api/getPositionClientByIdAndIsoCode';
  public static getCurrenciesUrl = 'client360-api/getCurrencies';
  public static getClientAndPositionUrl =
    'client360-api/getClientAndPositionClientById';
  public static getDynamicformsUrl = 'client360-api/getDynamicFormInputsAtDate';
  public static saveScore01000ResponsesUrl =
    'client360-api/savePersonFormResponses';
  public static saveManualPersonScoreUrl =
  'client360-api/saveManualPersonScore';
  public static scoreExecuteFlowUrl = 'client360-api/scoreExecuteFlow';
  public static findPersonScoresByDniPaginatedUrl =
  'client360-api/findPersonScoresByDniPaginated';
  public static labelScore = 'client360-api/getOptionsOfCombobox';
  public static findParametersGroup =
    'client360-api/getParametersByParameterGroup/';
  public static findLinesByDebtorIdAndStateTagPaginated =
    'api-segurocredito/findLinesByDebtorIdAndStateTagPaginated';
  public static findLineScoreByIdDebtor =
    'api-segurocredito/findLineScoreByIdDebtor';
  public static findMinutascoring =
    'amaru-api-caucion/minuta/findMinutaScoring';
  public static saveProspecScore = 
   'client360-api/saveProspectScore';  
  public static saveProspectFormResponses = 
  'client360-api/saveProspectFormResponses';  
  public static prospectScoreExecuteFlow = 
  'client360-api/prospect/scoreExecuteFlow';  
  public static findProspectScoresPaginated = 
  'client360-api/findProspectScoresPaginated'
  public static updateProspect = 
  'client360-api/prospectToPersonScore';
  public static updateStatus = 
  'client360-api/updateScoreStatus'
  public static findProspectFormResponse = 
  'client360-api/findProspectFormResponse'
  public static EEFF_TYPE = 'EEFF_TYPE'
  public static scoreAnalytics = 'client360-api/getAnalyticsInformation';
  public static amaruGroupEconomic = 'amaru-api-cliente/grupo-economico/consulta'
  public static findSourceSystems = 'client360-api/findSourceSystem';
  public static getLevelsScore = 'client360-api/getLevelScore';

  public industriesSub: BehaviorSubject<any> = new BehaviorSubject<any>([]);
  public subIndustriesSub: BehaviorSubject<any> = new BehaviorSubject<any>([]);

  public getIdustries = this.industriesSub.asObservable();
  public getSubindustries = this.subIndustriesSub.asObservable();
  public getCorporateMershFromExternalSourceURL =
    'api-external-documents/process-request';
  public static findBranchAndCoveragesByOperationId =
    'api-artico/api/v1/artico-mp/policy-query-front/detail';

  constructor(
    protected restClientService: AvlaRestClientService,
    protected datePipe: DatePipe,
    protected requestStore: DeductibleRequestStoreService 
  ) {}

  public static createScoreTable(
    objectScores: C360PersonScoreDTO | C360ProspectScoreDTO,
    scoresNames: any[],
    transNames: any,
    i18n: any,
    prospect: boolean = false
  ): ScoreTableItem[] {
    const scoresTable: ScoreTableItem[] = [];

    if (!objectScores) return scoresTable;
    let scores;
    if (Object.prototype.hasOwnProperty.call(objectScores, 'prospectScoresData')) {
      scores = (objectScores as C360ProspectScoreDTO).prospectScoresData;
    } else {
      scores = (objectScores as C360PersonScoreDTO).personScoresData;
    }
    
    for (const score of Object.keys(scores)) {
     
      if(prospect) {
        scoresNames = scoresNames.filter(score => !['guaranteeScore', 'productConditionScore'].includes(score));
      }
      if (
        score === 'companyTotal' ||
        (objectScores.business === 'GT' && score === 'operationTotal' && !prospect || 
        (objectScores.business === 'GT' && score === 'internalCompanyScore'))
      ) {
          const scoreName = ClientService.getConstantRowLabel(score);
          scoresTable.push(
            ScoreTableItem.createScoreObject(
              score,
              i18n.getTranslation(scoreName),
              scores[score],
              1,
              ClientService.getOrderByScore(score)
            )
          );
      } else if (ScoreConfigFactory.isFromArtico(objectScores.business) && score === 'generalTotal') {
        continue;
      } else if (scoresNames.includes(score)) {       
        scoresTable.push(
          ScoreTableItem.createScoreObject(
            score,
            transNames[score],
            scores[score],
            2,
            ClientService.getOrderByScore(score)
          )
        );
      }
      else if (score === 'expirationDateStr') { 
        if(scores[score]) {
          scoresTable.push(
            ScoreTableItem.createScoreObject(
              score,
              i18n.getTranslation('C360C_scoreVisualizerComponent_VigencyRow'),
              scores[score],
              1,
              ClientService.getOrderByScore(score)
            )
          );
        } else {
          scoresTable.push(
            ScoreTableItem.createScoreObject(
              score,
              i18n.getTranslation('C360C_scoreVisualizerComponent_VigencyRow'),
              '',
              1,
              ClientService.getOrderByScore(score)
            )
          );
        }

      }

    }
    return scoresTable.sort((a, b) => a.order - b.order);
  }

  public static getOrderByScore(score: string): number {
    let order: number;
    switch (score) {
      case 'internalCompanyScore':
        order = 0;
        break;
      case 'companyTotal':
        order = 1;
        break;
      case 'industryScore':
        order = 2;
        break;
      case 'characterScore':
        order = 3;
        break;
      case 'operationalCapacityScore':
        order = 4;
        break;
      case 'financeScore':
        order = 5;
        break;
      case 'operationTotal':
        order = 6;
        break;
      case 'productConditionScore':
        order = 7;
        break;
      case 'guaranteeScore':
        order = 8;
        break;
      case 'expirationDateStr':
        order = 9
      default:
        order = 10;
        break;
    }
    return order;
  }

  public setIdustries(industries) {
    this.industriesSub.next(industries);
  }

  public setSubIdustries(industries) {
    this.subIndustriesSub.next(industries);
  }

  public getClientsList(searchCriteria: string): Observable<clientDataDto> {
    return this.restClientService.getList(ClientService.getClienturl, [], {
      dniOrName: searchCriteria,
    });
  }

  public searchClientResults(dniOrName: string): Observable<clientResultsDto> {
    return this.restClientService.getList(
      ClientService.getClientResult,
      [],
      { dniOrName },
      null
    );
  }

  public searchClientResultsES(
    dniOrName: string,
    offset: number,
    limit: number
  ): Observable<clientResultsDto> {
    return this.restClientService.getList(
      ClientService.getClientResultES,
      [],
      {
        dniOrName: encodeURIComponent(dniOrName),
        offset,
        limit,
      },
      null
    );
  }

  public generateDoc(dataClient: any, type: string) {
    return this.restClientService.post(
      ClientService.generateDocUrl,
      null,
      { documentType: type },
      dataClient
    );
  }

  public saveScore01000Responses(
    business: string,
    dni: string,
    operationId: number,
    formData: any,
    saveScore: boolean,
    cdCountry: string,
    groupedResponses = false
  ): Observable<C360PersonFormResponsesDTO[]> {
    const queryStrings = {
      dni: encodeURIComponent(dni),
      operationId,
      saveScore,
      cdCountry,
      business,
      groupedResponses
    };
    return this.restClientService.post(
      ClientService.saveScore01000ResponsesUrl,
      null,
      queryStrings,
      formData
    );
  }

  public findPersonScoresByDniPaginated(
    dni: string,
    operationId: number,
    personFormResponsesId: number,
    cdCountry: string,
    business?: string,
    pageLength?: number
  ) {
    const params = { dni: encodeURIComponent(dni), cdCountry };
    if (personFormResponsesId) {
      params['personFormResponsesId'] = personFormResponsesId;
    }

    if (undefined === pageLength || null === pageLength) {
      pageLength = 10;
    }
    if (business) {
      params['business'] = business;
    }
    if (operationId) {
      params['operationId'] = operationId;
    }
    params['showIsLast'] = true;
    return this.restClientService.getPaginatedList(
      ClientService.findPersonScoresByDniPaginatedUrl,
      null,
      params,
      pageLength,
      1,
      'personScoreId',
      'desc'
    );
  }

  public findCompanyScoresPaginated(
    dni: string,
    business: string,
    cdCountry: string,
    limit: number,
    offset: number,
    origin: string,
    state: string = 'PROSPECT',
    isLast=true
  ) {
		const params = {
			limit,
			offset,
			cdCountry,
			isLast,
      state
		};

    if (dni) {
      params['dni'] = encodeURIComponent(dni);
    }
    if (business) {
      params['business'] = business;
    }

    if (cdCountry) {
      params['cdCountry'] = cdCountry;
    }
    if (origin) {
      params['origin'] = origin;
    }
    
    return this.restClientService.getList(ClientService.findProspectScoresPaginated, null, params)

  }

  public scoreExecuteFlow(
    c360PersonFormResponsesExecuteFlowDTO,
    cdCountry: string,
    recalculateMode: boolean,
    isSave: boolean = false
  ): Observable<C360PersonScoreDTO> {
    const params = {
      saveScore: isSave,
      cdCountry,
      recalculateMode,
    };
    return this.restClientService.post(
      ClientService.scoreExecuteFlowUrl,
      null,
      params,
      c360PersonFormResponsesExecuteFlowDTO
    );
  }

  public saveManualPersonScore(
    scoresMap,
    dni: string,
    operationId: number,
    formName: string,
    formResponsesId: number,
    business: string,
    cdCountry: string,
    groupedFormResponsesId?: number
  ): Observable<C360PersonScoreDTO[]> {
    const params = {
      dni: encodeURIComponent(dni),
      operationId,
      cdCountry,
    };
    if (formName) {
      params['formName'] = formName;
    }
    if (business) {
      params['business'] = business;
    }
    if (formResponsesId) {
      params['formResponsesId'] = formResponsesId;
    }
    if (groupedFormResponsesId) {
      params['groupedFormResponsesId'] = groupedFormResponsesId;
    }
    return this.restClientService.post(
      ClientService.saveManualPersonScoreUrl,
      null,
      params,
      scoresMap
    );
  }

  public getCorporateMersh(clientDNI: string) {
    const data = {
      rut: clientDNI,
    };

    const queryStrings = {
      cdCountry: 'CL',
      sourceName: 'MallaSocietaria',
      force: 'false',
    };

    return this.restClientService.post(
      this.getCorporateMershFromExternalSourceURL,
      null,
      queryStrings,
      data
    );
  }

  public getProductData(clientId: string, isoCd: string) {
    return this.restClientService.getList(
      ClientService.getProductUrl,
      [],
      { idClient: clientId, isoCode: isoCd },
      null
    );
  }

  public getCurrencies() {
    return this.restClientService.getList(
      ClientService.getCurrenciesUrl,
      null,
      null
    );
  }

  public getInfoClient(idClient: any) {
    return this.restClientService.getList(
      ClientService.getClientAndPositionUrl,
      [],
      { idClient },
      null
    );
  }

  public getDinamicformInputs() {
    return this.restClientService.getList(
      ClientService.getDynamicformsUrl,
      [],
      { formName: 'FORMS_DYNAMICDATA' },
      null
    );
  }

  public getLabelScore(business: string, country: string) {
    const codeCombobox = `lbl_score_${business}_${country}`;
    const params = {
      codeCombobox: codeCombobox,
      onlyEnabled: 'true',
      cdCountry: country,
    };

    return this.restClientService.getList(
      ClientService.labelScore,
      null,
      params
    );
  }

  public getLabelEEFF() {
    const params = {
      codeCombobox: 'EEFF_TYPE',
      onlyEnabled: 'true',
    };

    return this.restClientService.getList(
      ClientService.labelScore,
      null,
      params
    );
  }

  public calculateScoreVigency(
    score: number,
    business: string,
    country: string
  ) {
    return this.restClientService
      .getList(ClientService.findParametersGroup, null, {
        groupName: 'score_validity',
      })
      .pipe(
        map(ele => {
          let date = moment();

          const days0650 = ele.find(
            el =>
              el['countryCode'] === country &&
              el['name'] === 'score_validity_0_650'
          ).value;

          const days6501001 = ele.find(
            el =>
              el['countryCode'] === country &&
              el['name'] === 'score_validity_650_1001'
          ).value;

          switch (business) {
            case businessScore.GT:
              if (score >= 600) {
                console.log(days6501001);
                date = date.add(parseInt(days6501001), 'days');
                console.log(date.toDate());
              } else if (score < 600) {
                console.log(days0650);
                date = date.add(parseInt(days0650), 'days');
                console.log(date.toDate());
              }

              break;

            case businessScore.SC:
              if (score >= 700) {
                console.log(days6501001);
                date = date.add(parseInt(days6501001), 'days');
                console.log(date.toDate());
              } else if (score < 700) {
                console.log(days0650);
                date = date.add(parseInt(days0650), 'days');
                console.log(date.toDate());
              }

              break;
          }

          return date;
        })
      );
  }

  public validateIdOperation(
    idOperation: string,
    dni: string,
    cdCountry: string,
    cdCountryDebtor: string = cdCountry,
    business: string
  ): Observable<responsePaginatedDTO | resAmaruDTO | resArticoProposalDTO | {}> {
    const filter = `{"value":"${idOperation}","attributeNames":["lineId"],"comparator":"="}#{"value":"${dni}","attributeNames":["debtorDto.identityField"],"comparator":"="}`;   
    let params = {};

    let response;

    switch (business) {
      case 'SC':
        params = {
          limit: 1,
          offset: 0,
          cdCountry,
          filter,
        };

        response = this.restClientService.getPaginatedList(
          ClientService.findLinesByDebtorIdAndStateTagPaginated,
          null,
          params
        ) as Observable<responsePaginatedDTO>;
        break;

      case 'GT':
        params = {
          operationId: idOperation,
          dni: encodeURIComponent(dni),
          codEmpresa: amaruCodeCountry[cdCountry],
          'ngsw-bypass': 1,
        };

        response = this.restClientService.getSingle(
          ClientService.findMinutascoring,
          null,
          params
        ) as Observable<any>;
        break;
      case 'PC':
        params = {
          codEmpresa: cdCountry
        };

        const requestFn = () => this.restClientService.getSingle(
          `${ClientService.findBranchAndCoveragesByOperationId}/${idOperation}`,
          null,
          params
        ).pipe(
            map((res: resArticoProposalDTO) => {
              
              const { productMpDto, sections } = res;
              console.log({ productMpDto, sections });
              
             // 1. Extraer "sections" codificado en base64
              const base64Sections = sections;
              if (!base64Sections) {
                return [];
              }

              // 2. Decodificar y parsear
              let decoded: base64String[] = [];
              try {
                const jsonString = atob(base64Sections);
                decoded = JSON.parse(jsonString);
                console.log({decoded});
                
              } catch (e) {
                console.error('Error al decodificar y parsear sections', e);
                return [];
              }
              
              // 3. Validar si la respuesta es del mismo cliente
              // {
              //    "entity": "persona",
              //    "sectionCode": "asegurado",
              //    "attributes": { "documentValue": "123456789" }
              // }
              const assured = Array.isArray(decoded)
                ? decoded.find((item: any) =>
                    item?.entity === 'persona' &&
                    item?.sectionCode === 'asegurado' &&
                    item?.attributes?.documentValue === dni
                  )
                : null;

              if (!assured) {
                return [];
              }
              
              // 4. Filtrar todos los objetos con entity === "cobertura"
              const coverageList = Array.isArray(decoded)
                ? decoded.filter((item: any) => item?.entity === 'cobertura')
                : [];
              const coveragesResponse = coverageList.length === 0 ? [] : coverageList.map(coverage => ({
                section: coverage.section,
                sectionCode: coverage.sectionCode,
                deductibleRais: coverage.attributes?.deductibleRais
              }));
              
              // 5. Extraer el productMP
              const typeRisk = productMpDto?.group;
              if (!typeRisk) {
                return [];
              }
              const response = {
                coverages: coveragesResponse,
                typeRisk: typeRisk,
                assured: assured
              }
              console.log({response});
              return response;
            })
        ) as Observable<any[]>;
        response = requestFn();

        this.requestStore.setRequest(requestFn);

        response = requestFn();
        break;
        
      default:
        return of({});
    }

    return response;
  }

  public findLineScoreByIdDebtor(
    id: number,
    cdCountry: string
  ): Observable<LineScoreDto> {
    const queryStrings = {
      cdCountry,
    };

    return this.restClientService.getSingle(
      ClientService.findLineScoreByIdDebtor,
      id,
      queryStrings
    );
  }

  public saveProspectScore(
    scoresMap,
    dni: string,
    formName: string,
    formResponsesId: number,
    business: string,
    cdCountry: string,
    name: string
  ): Observable<C360ProspectScoreDTO[]> {
    const params = {
      ...(dni ? { dni: encodeURIComponent(dni) } : {}),
      cdCountry,
    };
    if (formName) {
      params['formName'] = formName;
    }
    if (business) {
      params['business'] = business;
    }
    if (formResponsesId) {
      params['formResponsesId'] = formResponsesId;
    }
    if (name) {
      params['name'] = name;
    }
    return this.restClientService.post(
      ClientService.saveProspecScore,
      null,
      params,
      scoresMap
    );
  }
  public saveProspectFormResponses(
    formName: string,
    dni: string,
    formData: any,
    saveScore: boolean,
    cdCountry: string
  ): Observable<C360ProspectFormResponsesDTO> {
    const queryStrings = {
      formName,
      ...(dni ? { dni: encodeURIComponent(dni) } : {}),
      saveScore,
      cdCountry,
    };
    return this.restClientService.post(
      ClientService.saveProspectFormResponses,
      null,
      queryStrings,
      formData
    );
  }
  public prospectScoreExecuteFlow(
    c360ProspectFormResponsesExecuteFlowDTO,
    cdCountry: string,
    recalculateMode: boolean,
    isSave: boolean = false
  ): Observable<C360ProspectScoreDTO> {
    const params = {
      saveScore: isSave,
      cdCountry,
      recalculateMode,
    };
    return this.restClientService.post(
      ClientService.prospectScoreExecuteFlow,
      null,
      params,
      c360ProspectFormResponsesExecuteFlowDTO
    );
  }

  public findProspectFormResponse(id: number) {
    return this.restClientService.getSingle(
      ClientService.findProspectFormResponse,
      id
    );
  }

  public updateProspect(
    scoresData,
    prospectId?: number,
    dni?: string,
    name?: string,
    operationId?: number,
    formResponsesId?: number
  ) {
    const params = {};
    if (prospectId) {
      params['prospectId'] = prospectId;
    }
    if (dni) {
      params['dni'] = encodeURIComponent(dni);
    }
    if (name) {
      params['name'] = name;
    }
    if (operationId) {
      params['operationId'] = operationId;
    }
    if (formResponsesId) {
      params['formResponsesId'] = formResponsesId;
    }
    return this.restClientService.post(
      ClientService.updateProspect,
      null,
      params,
      scoresData
    );
  }

  public updateStatus(
    scoresData: {
      personScoreId: number;
      status:        string;
    }
  ) {
    return this.restClientService.edit(
      ClientService.updateStatus,
      null,
      null,
      scoresData
    );
  }
  
  public dataAnalytics(personDni: any, cdCountry: string, business: string) {
    const params = {};
    if (cdCountry) {
      params['cdCountry'] = cdCountry;
    }

    if (business) {
      params['business'] = business;
    }
    if (business) {
      params['personDni'] = personDni;
    }
    return this.restClientService.getSingle(
      ClientService.scoreAnalytics,
      null,
      params,
      null
    );
  }

  public getLevelsInfo(levelOne: string, levelTwo: string, levelThree: string, cdCountry: string) {
    if (!levelOne || !levelTwo || !levelThree) {
      return null;
    }

    const params = {
      levelOne,
      levelTwo,
      levelThree,
      cdCountry
    };
    
    return this.restClientService.getSingle(
      ClientService.getLevelsScore,
      null,
      params,
      null
    );
  } 

  public findSourceSystems(cdCountry: string): Observable<SourceSystemDTO[]> {
    const params = {};
    if (cdCountry) {
      params['cdCountry'] = cdCountry;
    }
    return this.restClientService.getSingle(
      ClientService.findSourceSystems,
      null,
      params,
      null
    );
  }

  public getVigencyDaysThreshold() {
    const url = `client360-api/getParameter/*/VIGENCY_DAYS_TRESHOLD`;
    return this.restClientService.getList(
      url,
      null,
      null
    );
  }

  public getGroupEconomic(groupEconomicId: number, cdCountry: string): Observable<AmaruEconomicGroupDTO> {

    const params = {
          codEmpresa: amaruCodeCountry[cdCountry],
          'ngsw-bypass': 1,
    };

    return this.restClientService.getSingle(
      ClientService.amaruGroupEconomic,
      groupEconomicId,
      params
    );
  }
  
  public static getConstantRowLabel(score) {
    let scoreName: string;

    switch (score) {
      case 'operationTotal':
        scoreName = 'C360C_clientInfoComponent_OPERATION_TOTAL';
        break;
      case 'internalCompanyScore':
        scoreName = 'C360C_clientInfoComponent_INTERNAL_COMPANY_SCORE';
        break;
      default:
        scoreName = 'C360C_clientInfoComponent_COMPANY_TOTAL';
        break;
    }
    return scoreName;
  }

  public getTypeRisk(cdCountry:string) {
    const codeCombobox = `type_risk_${cdCountry}_PC`;
    const params = {
      codeCombobox: codeCombobox,
      onlyEnabled: 'true'
    };
    return this.restClientService.getList(
      ClientService.labelScore,
      null,
      params
    );
  }

  public getScoreConfig(cdCountry:string, business: string): Observable<ScoreConfig> {
    const parameterGroup = `score_config_${business}_${cdCountry}`;
    return this.restClientService
      .getList(ClientService.findParametersGroup, null, { groupName: parameterGroup })
      .pipe(
        map((responseParams: ParameterDTO[]) => {
          if (!responseParams || responseParams.length === 0) {
            console.warn('No se encontraron parámetros para el grupo solicitado');
            return null;
          }

          const response = responseParams[0];
          try {
            return JSON.parse(response.value);
          } catch (e) {
            console.error('Error al parsear JSON:', e);
            return null;
          }
        })
      );
  }

  public getOrigins() {
    const codeCombobox = 'cb_score_origins';
    const params = {
      codeCombobox: codeCombobox,
      onlyEnabled: 'true'
    };
    return this.restClientService.getList(
      ClientService.labelScore,
      null,
      params
    );
  }
}
